<template>
  <div class="content-wrapper">
    <b-loading :is-full-page="false" :active="loading" />

    <b-message v-if="error" type="is-danger" has-icon icon-size="is-small">
      {{ $t('failed-fetch-tasks') }}
    </b-message>

    <div v-else>
      <AppUploadPanel @task-upload:success="handleTaskUploaded" />

      <InferencePipelinePanel />

      <AppListPanel :applications="applications" />
    </div>
  </div>
</template>

<script>
import AppListPanel from '@/components/appengine/panels/AppListPanel.vue';
import InferencePipelinePanel from '@/components/appengine/panels/InferencePipelinePanel.vue';
import AppUploadPanel from '@/components/appengine/panels/AppUploadPanel.vue';
import Task from '@/utils/appengine/task';

const SUPERSEDED_BY_INFERENCE = 'ai.zaya.pipeline.tbsputum';

export default {
  name: 'AppLocalPage',
  components: {
    AppListPanel,
    AppUploadPanel,
    InferencePipelinePanel,
  },
  data() {
    return {
      applications: [],
      error: '',
      loading: true,
    };
  },
  async created() {
    try {
      let all = await Task.fetchAll();
      // The RF-DETR inference pipeline replaces this import task in the UI (it runs the
      // model rather than importing a .pkl produced elsewhere). The task stays registered
      // and callable via the API; it is only hidden from the catalog so the page does not
      // offer two things called "TB Sputum".
      this.applications = all.filter(t => t.namespace !== SUPERSEDED_BY_INFERENCE);
    } catch (error) {
      this.error = error.message;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    handleTaskUploaded(task) {
      this.applications.push(task);
    },
  }
};
</script>
